/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Fs_OnlyInputs */

const en_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FS Only`)
};

const fr_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FS uniquement`)
};

const de_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur FS`)
};

const it_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo FS`)
};

const ru_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только FS`)
};

const es_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo FS`)
};

const zh_cn2_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限FS`)
};

const ja_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FSのみ`)
};

const hi_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल एफएस`)
};

const pt_pt2_dialogue_list_export_fs_only = /** @type {(inputs: Dialogue_List_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente FS`)
};

/**
* | output |
* | --- |
* | "FS Only" |
*
* @param {Dialogue_List_Export_Fs_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_fs_only = /** @type {((inputs?: Dialogue_List_Export_Fs_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Fs_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_fs_only(inputs)
	if (locale === "de") return de_dialogue_list_export_fs_only(inputs)
	if (locale === "it") return it_dialogue_list_export_fs_only(inputs)
	if (locale === "ru") return ru_dialogue_list_export_fs_only(inputs)
	if (locale === "es") return es_dialogue_list_export_fs_only(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_fs_only(inputs)
	if (locale === "ja") return ja_dialogue_list_export_fs_only(inputs)
	if (locale === "hi") return hi_dialogue_list_export_fs_only(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_fs_only(inputs)
	return en_dialogue_list_export_fs_only(inputs)
});